import { Button, Icon, Modal } from 'antd'
import React, { useState } from 'react'

import BeginningOfLessonImg from '../../../../../../assets/beginning_of_lesson.svg'
import EndOfLessonImg from '../../../../../../assets/end_of_lesson.svg'
import CurrentlyActivePageImg from '../../../../../../assets/currently_active_page.svg'
import { useTranslation } from 'react-i18next'

const postions = {
  start: 'start',
  end: 'end',
  current: 'current'
}

function AiQuizPageSelection({ onClose, onPosition }) {
  const [selectedPosition, setSelectedPosition] = useState(postions.current)
  const { t } = useTranslation()

  const onAdd = () => {
    Modal.confirm({
      title: t('v4:confirm_selection'),
      content: t('v4:quiz_page_this_cannot_be_done'),
      centered: true,
      onOk: () => {
        onPosition(selectedPosition)
        onClose()
      },
      okText: t('v4:ok'),
      cancelText: t('v4:cancel')
    })
  }

  return (
    <Modal centered visible={true} footer={null} width={'80%'} closable={false}>
      <div className="ai-quiz-page-selection-header">
        <div className="ai-quiz-page-selection-header-title">
          <h1>{t('v4:select_quiz_page')}</h1>
          <p>{t('v4:lesson_do_you_want_add_this_quiz')}</p>
        </div>

        <Icon onClick={onClose} className="close-icon" type="close" />
      </div>
      <div className="ai-quiz-page-selection-body">
        <div className="ai-quiz-page-selection-body-container">
          <div
            className={`ai-quiz-page-selection-body-container-item ${
              selectedPosition === postions.start ? 'active' : ''
            }`}
            onClick={() => setSelectedPosition(postions.start)}
          >
            <img src={BeginningOfLessonImg} alt="beginning_of_lesson" />
            <p>{t('v4:beginning_of_lesson')}</p>
          </div>
          <div
            className={`ai-quiz-page-selection-body-container-item ${
              selectedPosition === postions.end ? 'active' : ''
            }`}
            onClick={() => setSelectedPosition(postions.end)}
          >
            <img src={EndOfLessonImg} alt="beginning_of_lesson" />
            <p>{t('v4:end_of_lesson')}</p>
          </div>
          <div
            className={`ai-quiz-page-selection-body-container-item ${
              selectedPosition === postions.current ? 'active' : ''
            }`}
            onClick={() => setSelectedPosition(postions.current)}
          >
            <img src={CurrentlyActivePageImg} alt="beginning_of_lesson" />
            <p>{t('v4:currently_active_page')}</p>
          </div>
        </div>

        <div className="ai-quiz-page-selection-action">
          <Button
            shape="round"
            size="large"
            className="ai-quiz-page-selection-action-btn"
            onClick={onAdd}
          >
            {t('v4:finish')}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default AiQuizPageSelection
